export default "__VITE_ASSET__BhA3_WiC__"